import { Action } from "../actions/steps";

const initialState = {
    onBoardingSteps: {}
};
export default function onBoardingSteps(state = initialState, action: Action): any {
    switch (action.type) {
      case 'SET_ONBOARDING_STEPS':
        return {
          ...state,
          onBoardingSteps: action.state,
        };
      case 'UPDATE_ONBOARDING_STEPS':
        const newObject = {
          ...state.onBoardingSteps
        }
        newObject[action.state] = true;
        return{
          ...state,
          onBoardingSteps: newObject
        }
      default:
        return state;
    }
  }
  
